var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        { attrs: { align: "center" } },
        [
          _c("v-col", { attrs: { cols: "7" } }, [
            _c(
              "p",
              { staticClass: "text-h3 font-weight-bold d-inline-block mb-0" },
              [_vm._v("TVOC")]
            )
          ]),
          _c("v-col", { attrs: { cols: "5" } }, [
            _c("div", { staticClass: "align-end text-right" }, [
              _c(
                "p",
                { staticClass: "text-h5 grey--text font-weight-bold mb-0" },
                [_vm._v("ppm")]
              )
            ])
          ])
        ],
        1
      ),
      _c("v-divider", { staticClass: "mt-8 mb-8" }),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-justify" }, [
      _c("p", [
        _vm._v(
          " An indoor environment with high TVOC levels can have various adverse effects on your health. Some of the most common symptoms of VOC exposure include : Eye, Nose, and Throat Irritation, Headaches, Nausea and Fatigue, Allergies, Nasal and Sinus Congestion, Wheezing and Coughing. "
        )
      ]),
      _c("p", [_vm._v("• TVOC Safe Levels: 0.3-0.5 mg/m3")]),
      _c("p", [_vm._v("• TVOC Potentially Dangerous Levels: .5-1 mg/m3")]),
      _c("p", [_vm._v("• TVOC Highly Dangerous Levels: 1-3 mg/m3")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }